<template>
  <div class="tg-btn--switch">
    <div class="switch-item">
      <i v-if="leftIcon">
        <slot name="leftIcon">
          <font-awesome-icon :icon="leftIcon" size="1x"></font-awesome-icon>
        </slot>
      </i>
      <span @click="handleClick(true)">{{leftLabel}}</span>
    </div>
    <el-divider direction="vertical"></el-divider>
    <div class="switch-item">
      <i v-if="rightIcon">
        <slot name="rightIcon">
          <font-awesome-icon :icon="rightIcon" size="1x"></font-awesome-icon>
        </slot>
      </i>
      <span @click="handleClick(false)">{{rightLabel}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftLabel: String,
    rightLabel: String,
    leftIcon: [String, Array],
    rightIcon: [String, Array]
  },
  methods: {
    handleClick(status) {
      this.$emit("on-click", status);
    }
  }
};
</script>